import React from "react";
import { useTranslation } from "react-i18next";
import { GebrekenTableRow } from "./GebrekenTableRow";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { Bevinding } from "@/features/gebreken/types/bevinding";
import type { ProjectImage } from "@/features/gebreken/hooks/useProjectImages";

interface GebrekenCardsDisplayProps {
  bevindingen: Bevinding[];
  images: ProjectImage[];
}

/**
 * Table component for displaying gebreken in the protected section.
 * Looks like a normal table but with tooltip to indicate it's AI-managed.
 */
export const GebrekenCardsDisplay: React.FC<GebrekenCardsDisplayProps> = ({
  bevindingen,
  images,
}) => {
  const { t } = useTranslation("common");

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="cursor-not-allowed">
            <table className="border-collapse border border-border my-4 w-full">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th className="border border-border px-3 py-2 text-left align-top font-bold bg-muted">
              {t("editor.protectedSection.gebreken.table.referentie")}
            </th>
            <th className="border border-border px-3 py-2 text-left align-top font-bold bg-muted">
              {t("editor.protectedSection.gebreken.table.gebrek")}
            </th>
            <th className="border border-border px-3 py-2 text-left align-top font-bold bg-muted">
              {t("editor.protectedSection.gebreken.table.maatregel")}
            </th>
            <th className="border border-border px-3 py-2 text-left align-top font-bold bg-muted">
              {t("editor.protectedSection.gebreken.table.voorschrift")}
            </th>
            <th className="border border-border px-3 py-2 text-left align-top font-bold bg-muted">
              {t("editor.protectedSection.gebreken.table.fotos")}
            </th>
          </tr>
        </thead>
        <tbody>
          {bevindingen.length > 0 ? (
            bevindingen.map((bevinding, index) => (
              <GebrekenTableRow
                key={bevinding.id}
                bevinding={bevinding}
                index={index}
                images={images}
              />
            ))
          ) : (
            <tr>
              <td className="border border-border px-3 py-2 text-left align-top">
                <p className="m-0 p-0 leading-relaxed">1</p>
              </td>
              <td className="border border-border px-3 py-2 text-left align-top">
                <p className="m-0 p-0 leading-relaxed"></p>
              </td>
              <td className="border border-border px-3 py-2 text-left align-top">
                <p className="m-0 p-0 leading-relaxed"></p>
              </td>
              <td className="border border-border px-3 py-2 text-left align-top">
                <p className="m-0 p-0 leading-relaxed"></p>
              </td>
              <td className="border border-border px-3 py-2 text-left align-top">
                <p className="m-0 p-0 leading-relaxed"></p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t("editor.protectedSection.gebreken.tooltip")}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
